/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import IntegrationsformsortFormsortIntegration from './IntegrationsformsortFormsortIntegration';

/**
 * The IntegrationsFormsortBody model module.
 * @module model/IntegrationsFormsortBody
 * @version v0.3
 */
export default class IntegrationsFormsortBody {
  /**
   * Constructs a new <code>IntegrationsFormsortBody</code>.
   * @alias module:model/IntegrationsFormsortBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>IntegrationsFormsortBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationsFormsortBody} obj Optional instance to populate.
   * @return {module:model/IntegrationsFormsortBody} The populated <code>IntegrationsFormsortBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new IntegrationsFormsortBody();
      if (data.hasOwnProperty('formsort_integration'))
        obj.formsortIntegration = IntegrationsformsortFormsortIntegration.constructFromObject(data['formsort_integration']);
    }
    return obj;
  }
}

/**
 * @member {module:model/IntegrationsformsortFormsortIntegration} formsortIntegration
 */
IntegrationsFormsortBody.prototype.formsortIntegration = undefined;

